<script>
export default {
  props: {
    disableAnimation: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  render (createElement) {
    // Get the default slot's children
    const defaultSlot = this.$slots.default

    // If no slot content, don't render anything
    if (!defaultSlot || defaultSlot.length === 0) {
      return null
    }

    // Check if there is at least one child in the default slot
    if (defaultSlot && defaultSlot.length === 1) {
      let props = {}

      const { staticClass, ...restProps } = defaultSlot[0].data ?? {}

      props = {
        class: [staticClass, 'slide-out-container', this.className].filter(Boolean),
        ...restProps
      }

      const clonedChild = createElement(
        defaultSlot[0].tag,
        props,
        defaultSlot[0].children
      )

      if (this.disableAnimation) {
        return createElement('div', { class: ['slide-out-container', this.className].filter(Boolean) }, [clonedChild])
      }

      return createElement(
        'transition',
        {
          props: {
            name: 'show'
          }
        },
        [clonedChild]
      )
    } else {
      // If there is no child or more than one child, just return the original slot content
      return createElement('div', { class: ['slide-out-container', this.className].filter(Boolean) }, this.$slots.default)
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-out-container {
  width: 100%;
  min-height: -webkit-fill-available;
  background: #F3F5F7;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  margin-left: 0;
}
.show-enter-active,
.show-leave-active {
  transition: margin-left 0.5s;
}
.show-enter,
.show-leave-to {
  margin-left: 100%;
}
</style>

<style>
.main-content:has(.slide-out-container.show-leave-active),
.main-content:has(.slide-out-container.show-enter-active) {
  overflow-x: clip;
}

</style>
